<!-- HTML Template -->
<template>
  <div v-if="is_open">
    <div class="confirmation-popup-overlay">
      <div class="confirmation-popup">
        <h5>{{ title }}</h5>
        <p class="text-secondary">{{ description }}</p>

        <div class="confirmation-popup__buttons-container">
          <button class="ml-auto button button-m button-secondary mr-16" @click="closeModal()">{{ $t('common.cancel') }}</button>
          <button class="button button-m button-primary" @click="confirm()">{{ button_text }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Javascript -->
<script>
  export default {
    data() {
        return {
          is_open: false,
          title: '',
          description: '',
          data: {},
          type: '',
          button_text: ''
        }
    },
    computed: {

    },
    mounted() {
        console.log('Component mounted.')
    },
    created() {
      this.$root.$on('show_confirmation', (data) => {
        this.title = data.title;
        this.description = data.description;
        this.data = data.data;
        this.button_text = data.button_text;
        this.type = data.type;
        this.is_open = true;
      });
    },
    methods: {
      closeModal() {
        this.is_open = false
        this.title = '',
        this.description = '',
        this.type = '',
        this.data = {},
        this.button_text = ''
      },
      confirm() {
        this.$root.$emit('confirmed', this.type, this.data);
        this.closeModal();
      }
    }
  }
</script>
